export const LinkDownloadFileApk = `${window.location.origin}/app/ED3333.apk`;
export const LinkDownloadFileIOS = `${window.location.origin}/app/ed3333.mobileconfig`;
